import { Outlet } from 'react-router-dom';

export const CardDesignerOutlet = () => <Outlet />;
